import { Routes, Route } from "react-router-dom";
import ChatList from "@/pages/chat/ChatList";
import ChatConversation from "@/pages/chat/ChatConversation";

export default function ChatLayout({ basePath }) {
  return (
    <div className="h-full flex gap-6 p-6 overflow-hidden">
      <div className="hidden md:block w-80 shrink-0">
        <ChatList basePath={basePath} />
      </div>
      <div className="flex-1 min-w-0">
        <Routes>
          <Route index element={<ChatConversation basePath={basePath} />} />
          <Route path=":id" element={<ChatConversation basePath={basePath} />} />
        </Routes>
      </div>
    </div>
  );
}
